module.exports = __webpack_public_path__ + "img/register-check.e01594eb.svg";